import React, { useReducer, useState } from 'react'
import {
  Input,
  Form,
  Row,
  Col,
  Radio,
  Space,
  Checkbox,
  Button,
  Table,
} from 'antd'
import { FormInstance } from 'antd/lib/form'
import { filteDisabled, filteHidden } from '../ControlformState/useFormState'
import { useTypedSelector } from '../../redux/store'
import { formatStr, isResponseCodeSuccess } from '../../tools/util'
import Style from './detail.module.scss'
import { weightRules } from './maininfo'
import { ReactComponent as ImgCode } from '../../assets/img/svg/code.svg'
import reducer, {
  SmartRevenueData,
  defaultState,
  setSelectRevenueAction,
  setSelectedRowKeysAction,
  setSmartRevenueDataAction,
  setSmartRevenueVisibleAction,
  setTaxLoadingAction,
} from './reducer'
import CustomModal from '../../components/ModalUser'
import { GET_SMART_REVENUE_DATA } from '../../api/MaterialApi'
// 导入时自动获取税收分类编码
import { message } from 'antd'
import { getTaxCategoryByCategory } from '../../api/MaterialApi'
import TaxCategoryPicker, {
  TaxCategoryPicked,
} from '../../components/TaxCategoryPicker'

interface Props {
  form: FormInstance
  hasDelivery: boolean
  onChangeDelivery: (e: boolean) => void // 详询客服
  onFieldsChange: () => void
}

const smartRevenueColumns = [
  {
    key: 'index',
    title: '序号',
    width: 30,
    render: (text: string, record: SmartRevenueData, index: number) =>
      index + 1,
  },
  {
    dataIndex: 'parentName',
    title: '税收分类名称',
    width: 110,
  },
  {
    dataIndex: 'shortName',
    title: '简称',
    width: 110,
  },
  // {
  //   dataIndex: 'prob',
  //   title: '匹配度',
  //   width: 80,
  // },
  {
    dataIndex: 'revenueCode',
    title: '税收分类编码',
    width: 100,
  },
  {
    dataIndex: 'taxRate',
    title: '税率',
    width: 80,
  },
]

// 次要信息
const Secondaryinfo: React.FC<Props> = (props) => {
  const { form, hasDelivery, onChangeDelivery, onFieldsChange } = props
  const { FormState } = useTypedSelector((state) => state.ControlformState)
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  // 选码弹窗只影响本组件展示，不入页面 reducer
  const [taxPickerVisible, setTaxPickerVisible] = useState(false)
  const {
    selectedRowKeys,
    smartRevenueVisible,
    smartRevenueData,
    selectRevenue,
    taxLoading,
  } = pagesstate

  // 获取智能赋码数据
  const handleTaxCategory = async () => {
    if (taxLoading) return
    const name = form.getFieldValue('name')
    if (!name) {
      message.error('请填写物料名称')
      return
    }
    dispatch(setTaxLoadingAction(true))
    const tip = message.loading('正在获取税编信息，请稍等...', 0)
    const res = await GET_SMART_REVENUE_DATA({
      productName: name,
    })
    if (isResponseCodeSuccess(res.code)) {
      // 打开智能赋码弹框
      dispatch(setSmartRevenueVisibleAction(true))
      dispatch(setSmartRevenueDataAction(res.data))
      // 设置默认选中数据
      setSelectData(res.data[0])
    }
    dispatch(setTaxLoadingAction(false))
    tip()
  }
  // 点击单选框
  const handleRevenue = (
    selectedRowKeys: (string | number)[],
    selectedRows: SmartRevenueData[],
  ) => {
    setSelectData(selectedRows[0])
  }
  // 设置选中数据
  const setSelectData = (value: SmartRevenueData) => {
    dispatch(setSelectedRowKeysAction([value.revenueCode]))
    dispatch(setSelectRevenueAction(value))
  }
  // 选码弹窗回填：四个字段整组取 MPM 本地税编库的值，与智能赋码同一条回填路径
  const handlePickTaxCategory = (picked: TaxCategoryPicked) => {
    form.setFieldsValue({
      taxCategoryCode: picked.code,
      taxCategoryCodeName: picked.name,
      abbreviation: picked.shortName,
      // 税率字段校验要求两位小数，0.1 直接转字符串会变成 "0.1" 过不了校验
      taxCategoryRate: picked.rate === null ? '' : picked.rate.toFixed(2),
    })
  }

  // 确认智能赋码
  const handleConfirmSmartRevenue = () => {
    dispatch(setSmartRevenueVisibleAction(false))
    const { parentName, revenueCode, taxRate, shortName } = selectRevenue
    form.setFieldsValue({
      taxCategoryRate: taxRate,
      taxCategoryCodeName: parentName,
      abbreviation: shortName,
      taxCategoryCode: revenueCode,
    })
  }
  // 关闭智能赋码弹框
  const closeSmartRevenueVisible = () => {
    dispatch(setSmartRevenueVisibleAction(false))
  }
  // 长 宽 高 计算
  const onChange = () => {
    const length = form.getFieldValue('size1')
    const width = form.getFieldValue('size2')
    const height = form.getFieldValue('size3')
    if (length && width && height) {
      const volume = length * width * height
      if (volume.toString().length > 13) {
        return false
      }
      form.setFieldsValue({ volume: volume.toString() })
    }
    if (length >= 1600 || width >= 1600 || height >= 1600) {
      form.setFieldsValue({ isFreeShipping: '0' })
      form.setFieldsValue({ isOverLength: '1' })
    } else {
      form.setFieldsValue({ isFreeShipping: '1' })
      form.setFieldsValue({ isOverLength: '0' })
    }

    if (length < 1600 && width < 1600 && height < 1600) {
      form.setFieldsValue({ isFreeShipping: '1' })
      form.setFieldsValue({ isOverLength: '0' })
    }
  }

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  const itemLayou = {
    style: {
      width: '100%',
      marginBottom: '10px',
    },
  }
  // 如果税收分类编码填写了，按照填写内容进行赋值
  // 如果税收分类编码未填写，根据物料类目，调用MPM接口匹配类目的税收分类编码(mpm内为空，此行报错“类目下没找到税收分类编码”)
  const handleAutoAssignTaxCategory = async (form: FormInstance) => {
    const taxCategoryCode = form.getFieldValue('taxCategoryCode')
    const fourthCateMdmId = form.getFieldValue('fourthCateMdmId') // 物料类目 ID

    if (taxCategoryCode) {
      // 用户已填写，直接使用
      return true
    }

    if (!fourthCateMdmId) {
      message.error('缺少物料类目信息')
      return false
    }

    try {
      const code = await getTaxCategoryByCategory(fourthCateMdmId)

      if (code) {
        form.setFieldsValue({ taxCategoryCode: code })
        return true
      } else {
        message.error('类目下没找到税收分类编码')
        return false
      }
    } catch (e) {
      message.error('获取税收分类编码失败')
      return false
    }
  }

  const onFinish = async () => {
    try {
      // 1. 校验表单字段
      const values = await form.validateFields()

      // 2. 自动赋码逻辑
      const success = await handleAutoAssignTaxCategory(form)
      if (!success) return

      // 3. 提交数据（你可以替换成你自己的 API）
      console.log('准备提交的数据:', form.getFieldsValue())

      // 示例：调用新增/编辑接口
      // const res = await ADD_PRODUCTCHILD(form.getFieldsValue())
      // if (isResponseCodeSuccess(res.code)) {
      //   message.success('提交成功')
      // }
    } catch (error) {
      message.error('请检查输入内容')
    }
  }

  return (
    <Form
      {...formItemLayout}
      form={form}
      onFieldsChange={onFieldsChange}
      colon={false}
      labelAlign="right"
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <Row>
        <Col span={8}>
          <Form.Item
            label="条形码"
            name="barCode"
            rules={[
              {
                max: 20,
                message: '请输入长度1-20的条形码',
              },
            ]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'other')
            }}
            {...itemLayou}
          >
            <Input
              maxLength={20}
              placeholder="请输入"
              hidden={filteHidden('barCode', FormState)}
              disabled={filteDisabled('barCode', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="净重"
            name="netweight"
            rules={[...weightRules]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            {...itemLayou}
          >
            <Input
              placeholder="请输入"
              suffix="kg"
              disabled={filteDisabled('netweight', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="已停产"
            name="haltProduction"
            {...itemLayou}
            rules={[
              { required: true, validateTrigger: 'blur', message: '请选择' },
            ]}
            initialValue="0"
          >
            <Radio.Group size="small">
              <Radio value={'1'}>是</Radio>
              <Radio value={'0'}>否</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Form.Item
            wrapperCol={{ span: 24 }}
            style={{ marginBottom: '0px', padding: '0 0 0 30px' }}
          >
            <Input.Group compact size="small">
              <Form.Item
                name="size1"
                rules={[
                  {
                    pattern: /^[1-9]\d*$/,
                    whitespace: true,
                    message: '请输入正整数',
                  },
                ]}
                style={{ width: '25%', marginBottom: '10px' }}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '').replace(/^0+/, '')
                }}
              >
                <Input
                  disabled={filteDisabled('size1', FormState)}
                  onChange={onChange}
                  addonBefore="长"
                  placeholder="请输入"
                  suffix="mm"
                />
              </Form.Item>
              <Form.Item
                name="size2"
                rules={[
                  {
                    pattern: /^[1-9]\d*$/,
                    whitespace: true,
                    message: '请输入正整数',
                  },
                ]}
                style={{ width: '25%', marginBottom: '10px' }}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '').replace(/^0+/, '')
                }}
              >
                <Input
                  disabled={filteDisabled('size2', FormState)}
                  onChange={onChange}
                  addonBefore="宽"
                  placeholder="请输入"
                  suffix="mm"
                />
              </Form.Item>
              <Form.Item
                name="size3"
                rules={[
                  {
                    pattern: /^[1-9]\d*$/,
                    whitespace: true,
                    message: '请输入正整数',
                  },
                ]}
                style={{ width: '25%', marginBottom: '10px' }}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '').replace(/^0+/, '')
                }}
              >
                <Input
                  disabled={filteDisabled('size3', FormState)}
                  onChange={onChange}
                  addonBefore="高"
                  placeholder="请输入"
                  suffix="mm"
                />
              </Form.Item>
              <Form.Item
                name="volume"
                rules={[
                  {
                    max: 13,
                    type: 'string',
                    message: '最大长度13位',
                  },
                ]}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '')
                }}
                style={{ width: '25%', marginBottom: '10px' }}
              >
                <Input
                  addonBefore="体积"
                  placeholder="请输入"
                  disabled={filteDisabled('volume', FormState)}
                  maxLength={30}
                  suffix="mm³"
                  readOnly
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>
        </Col>

        <Col span={8}>
          <div className={Style['deliveryday']}>
            <Space>
              <Form.Item
                label="发货期"
                name="deliveryday"
                rules={
                  !hasDelivery
                    ? [
                        {
                          required: true,
                          pattern: /^[1-9][0-9]{0,8}$/,
                          message: '请输入9位以内正整数',
                        },
                      ]
                    : undefined
                }
              >
                <Input
                  placeholder="请输入"
                  suffix="天"
                  hidden={filteHidden('deliveryday', FormState)}
                  disabled={
                    filteDisabled('deliveryday', FormState)
                      ? true
                      : hasDelivery
                        ? true
                        : false
                  }
                />
              </Form.Item>
              <Checkbox
                onChange={(e) => {
                  e.target.checked && form.resetFields(['deliveryday'])
                  onChangeDelivery(e.target.checked)
                }}
                checked={hasDelivery}
                style={{ marginBottom: '25px' }}
              >
                详询客服
              </Checkbox>
            </Space>
          </div>
          <Form.Item name="deliveryDate" noStyle>
            <Input hidden />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="税收分类编码"
            name="taxCategoryCode"
            rules={[
              {
                required: false, // 7.1.3税收分类编码改为非必填
                pattern: /^[0-9]{19}$/,
                message: '请输入19位的数字或使用智能赋码填充',
              },
            ]}
          >
            <Input
              readOnly
              className={Style['tax-code-input']}
              placeholder="点击选择税收分类"
              onClick={() => setTaxPickerVisible(true)}
              suffix={
                <span onClick={handleTaxCategory}>
                  <ImgCode
                    style={{
                      width: '14px',
                      height: '14px',
                      marginRight: '3px',
                    }}
                  />
                  <Button type="link" style={{ padding: 0 }}>
                    <span>智能赋码</span>
                  </Button>
                </span>
              }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="税收分类名称"
            name="taxCategoryCodeName"
            rules={[
              {
                required: true,
                message: '最长40字',
                whitespace: true,
                max: 40,
              },
            ]}
          >
            <Input disabled placeholder="选择税收分类或智能赋码自动带出" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="简称"
            name="abbreviation"
            {...itemLayou}
            rules={[
              {
                required: true,
                whitespace: true,
                pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,40}$/,
                message: '最多40位中英文或数字',
              },
            ]}
          >
            <Input disabled placeholder="选择税收分类或智能赋码自动带出" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="税率"
            name="taxCategoryRate"
            rules={[
              {
                required: true,
                pattern: /^(0(\.\d{2})?)$/,
                message: '请输入小于1的两位小数数字',
              },
            ]}
          >
            <Input disabled placeholder="选择税收分类或智能赋码自动带出" />
          </Form.Item>
        </Col>
      </Row>
      {/* 选码弹窗 */}
      <TaxCategoryPicker
        visible={taxPickerVisible}
        onCancel={() => setTaxPickerVisible(false)}
        onConfirm={handlePickTaxCategory}
      />
      {/* 智能赋码弹框 */}
      <CustomModal
        open={smartRevenueVisible}
        title="智能赋码"
        modalCancel={closeSmartRevenueVisible}
        width={900}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button size="middle" onClick={closeSmartRevenueVisible}>
              取消
            </Button>
            <Button
              type="primary"
              size="middle"
              onClick={handleConfirmSmartRevenue}
            >
              确认
            </Button>
          </div>
        }
      >
        <Table
          rowKey="revenueCode"
          tableLayout="fixed"
          className={Style['revenue-table-box']}
          size="small"
          rowSelection={{
            selectedRowKeys: selectedRowKeys,
            type: 'radio',
            onChange: handleRevenue,
          }}
          onRow={(record) => ({
            onClick: () => setSelectData(record),
          })}
          dataSource={smartRevenueData}
          columns={smartRevenueColumns}
          pagination={false}
        />
      </CustomModal>
      {/* <Row>
        <Col span={24} style={{ textAlign: 'right', marginTop: 20 }}>
          <Button type="primary" onClick={onFinish}>
            提交
          </Button>
        </Col>
      </Row> */}
    </Form>
  )
}

export default Secondaryinfo
import React, { useReducer, useState } from 'react'
import {
  Input,
  Form,
  Row,
  Col,
  Radio,
  Space,
  Checkbox,
  Button,
  Table,
} from 'antd'
import { FormInstance } from 'antd/lib/form'
import { filteDisabled, filteHidden } from '../ControlformState/useFormState'
import { useTypedSelector } from '../../redux/store'
import { formatStr, isResponseCodeSuccess } from '../../tools/util'
import Style from './detail.module.scss'
import { weightRules } from './maininfo'
import { ReactComponent as ImgCode } from '../../assets/img/svg/code.svg'
import reducer, {
  SmartRevenueData,
  defaultState,
  setSelectRevenueAction,
  setSelectedRowKeysAction,
  setSmartRevenueDataAction,
  setSmartRevenueVisibleAction,
  setTaxLoadingAction,
} from './reducer'
import CustomModal from '../../components/ModalUser'
import { GET_SMART_REVENUE_DATA } from '../../api/MaterialApi'
// 导入时自动获取税收分类编码
import { message } from 'antd'
import { getTaxCategoryByCategory } from '../../api/MaterialApi'
import TaxCategoryPicker, {
  TaxCategoryPicked,
} from '../../components/TaxCategoryPicker'

interface Props {
  form: FormInstance
  hasDelivery: boolean
  onChangeDelivery: (e: boolean) => void // 详询客服
  onFieldsChange: () => void
}

const smartRevenueColumns = [
  {
    key: 'index',
    title: '序号',
    width: 30,
    render: (text: string, record: SmartRevenueData, index: number) =>
      index + 1,
  },
  {
    dataIndex: 'parentName',
    title: '税收分类名称',
    width: 110,
  },
  {
    dataIndex: 'shortName',
    title: '简称',
    width: 110,
  },
  // {
  //   dataIndex: 'prob',
  //   title: '匹配度',
  //   width: 80,
  // },
  {
    dataIndex: 'revenueCode',
    title: '税收分类编码',
    width: 100,
  },
  {
    dataIndex: 'taxRate',
    title: '税率',
    width: 80,
  },
]

// 次要信息
const Secondaryinfo: React.FC<Props> = (props) => {
  const { form, hasDelivery, onChangeDelivery, onFieldsChange } = props
  const { FormState } = useTypedSelector((state) => state.ControlformState)
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  // 选码弹窗只影响本组件展示，不入页面 reducer
  const [taxPickerVisible, setTaxPickerVisible] = useState(false)
  const {
    selectedRowKeys,
    smartRevenueVisible,
    smartRevenueData,
    selectRevenue,
    taxLoading,
  } = pagesstate

  // 获取智能赋码数据
  const handleTaxCategory = async () => {
    if (taxLoading) return
    const name = form.getFieldValue('name')
    if (!name) {
      message.error('请填写物料名称')
      return
    }
    dispatch(setTaxLoadingAction(true))
    const tip = message.loading('正在获取税编信息，请稍等...', 0)
    const res = await GET_SMART_REVENUE_DATA({
      productName: name,
    })
    if (isResponseCodeSuccess(res.code)) {
      // 打开智能赋码弹框
      dispatch(setSmartRevenueVisibleAction(true))
      dispatch(setSmartRevenueDataAction(res.data))
      // 设置默认选中数据
      setSelectData(res.data[0])
    }
    dispatch(setTaxLoadingAction(false))
    tip()
  }
  // 点击单选框
  const handleRevenue = (
    selectedRowKeys: (string | number)[],
    selectedRows: SmartRevenueData[],
  ) => {
    setSelectData(selectedRows[0])
  }
  // 设置选中数据
  const setSelectData = (value: SmartRevenueData) => {
    dispatch(setSelectedRowKeysAction([value.revenueCode]))
    dispatch(setSelectRevenueAction(value))
  }
  // 选码弹窗回填：四个字段整组取 MPM 本地税编库的值，与智能赋码同一条回填路径
  const handlePickTaxCategory = (picked: TaxCategoryPicked) => {
    form.setFieldsValue({
      taxCategoryCode: picked.code,
      taxCategoryCodeName: picked.name,
      abbreviation: picked.shortName,
      // 税率字段校验要求两位小数，0.1 直接转字符串会变成 "0.1" 过不了校验
      taxCategoryRate: picked.rate === null ? '' : picked.rate.toFixed(2),
    })
  }

  // 确认智能赋码
  const handleConfirmSmartRevenue = () => {
    dispatch(setSmartRevenueVisibleAction(false))
    const { parentName, revenueCode, taxRate, shortName } = selectRevenue
    form.setFieldsValue({
      taxCategoryRate: taxRate,
      taxCategoryCodeName: parentName,
      abbreviation: shortName,
      taxCategoryCode: revenueCode,
    })
  }
  // 关闭智能赋码弹框
  const closeSmartRevenueVisible = () => {
    dispatch(setSmartRevenueVisibleAction(false))
  }
  // 长 宽 高 计算
  const onChange = () => {
    const length = form.getFieldValue('size1')
    const width = form.getFieldValue('size2')
    const height = form.getFieldValue('size3')
    if (length && width && height) {
      const volume = length * width * height
      if (volume.toString().length > 13) {
        return false
      }
      form.setFieldsValue({ volume: volume.toString() })
    }
    if (length >= 1600 || width >= 1600 || height >= 1600) {
      form.setFieldsValue({ isFreeShipping: '0' })
      form.setFieldsValue({ isOverLength: '1' })
    } else {
      form.setFieldsValue({ isFreeShipping: '1' })
      form.setFieldsValue({ isOverLength: '0' })
    }

    if (length < 1600 && width < 1600 && height < 1600) {
      form.setFieldsValue({ isFreeShipping: '1' })
      form.setFieldsValue({ isOverLength: '0' })
    }
  }

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  const itemLayou = {
    style: {
      width: '100%',
      marginBottom: '10px',
    },
  }
  // 如果税收分类编码填写了，按照填写内容进行赋值
  // 如果税收分类编码未填写，根据物料类目，调用MPM接口匹配类目的税收分类编码(mpm内为空，此行报错“类目下没找到税收分类编码”)
  const handleAutoAssignTaxCategory = async (form: FormInstance) => {
    const taxCategoryCode = form.getFieldValue('taxCategoryCode')
    const fourthCateMdmId = form.getFieldValue('fourthCateMdmId') // 物料类目 ID

    if (taxCategoryCode) {
      // 用户已填写，直接使用
      return true
    }

    if (!fourthCateMdmId) {
      message.error('缺少物料类目信息')
      return false
    }

    try {
      const code = await getTaxCategoryByCategory(fourthCateMdmId)

      if (code) {
        form.setFieldsValue({ taxCategoryCode: code })
        return true
      } else {
        message.error('类目下没找到税收分类编码')
        return false
      }
    } catch (e) {
      message.error('获取税收分类编码失败')
      return false
    }
  }

  const onFinish = async () => {
    try {
      // 1. 校验表单字段
      const values = await form.validateFields()

      // 2. 自动赋码逻辑
      const success = await handleAutoAssignTaxCategory(form)
      if (!success) return

      // 3. 提交数据（你可以替换成你自己的 API）
      console.log('准备提交的数据:', form.getFieldsValue())

      // 示例：调用新增/编辑接口
      // const res = await ADD_PRODUCTCHILD(form.getFieldsValue())
      // if (isResponseCodeSuccess(res.code)) {
      //   message.success('提交成功')
      // }
    } catch (error) {
      message.error('请检查输入内容')
    }
  }

  return (
    <Form
      {...formItemLayout}
      form={form}
      onFieldsChange={onFieldsChange}
      colon={false}
      labelAlign="right"
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <Row>
        <Col span={8}>
          <Form.Item
            label="条形码"
            name="barCode"
            rules={[
              {
                max: 20,
                message: '请输入长度1-20的条形码',
              },
            ]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'other')
            }}
            {...itemLayou}
          >
            <Input
              maxLength={20}
              placeholder="请输入"
              hidden={filteHidden('barCode', FormState)}
              disabled={filteDisabled('barCode', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="净重"
            name="netweight"
            rules={[...weightRules]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            {...itemLayou}
          >
            <Input
              placeholder="请输入"
              suffix="kg"
              disabled={filteDisabled('netweight', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="已停产"
            name="haltProduction"
            {...itemLayou}
            rules={[
              { required: true, validateTrigger: 'blur', message: '请选择' },
            ]}
            initialValue="0"
          >
            <Radio.Group size="small">
              <Radio value={'1'}>是</Radio>
              <Radio value={'0'}>否</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Form.Item
            wrapperCol={{ span: 24 }}
            style={{ marginBottom: '0px', padding: '0 0 0 30px' }}
          >
            <Input.Group compact size="small">
              <Form.Item
                name="size1"
                rules={[
                  {
                    pattern: /^[1-9]\d*$/,
                    whitespace: true,
                    message: '请输入正整数',
                  },
                ]}
                style={{ width: '25%', marginBottom: '10px' }}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '').replace(/^0+/, '')
                }}
              >
                <Input
                  disabled={filteDisabled('size1', FormState)}
                  onChange={onChange}
                  addonBefore="长"
                  placeholder="请输入"
                  suffix="mm"
                />
              </Form.Item>
              <Form.Item
                name="size2"
                rules={[
                  {
                    pattern: /^[1-9]\d*$/,
                    whitespace: true,
                    message: '请输入正整数',
                  },
                ]}
                style={{ width: '25%', marginBottom: '10px' }}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '').replace(/^0+/, '')
                }}
              >
                <Input
                  disabled={filteDisabled('size2', FormState)}
                  onChange={onChange}
                  addonBefore="宽"
                  placeholder="请输入"
                  suffix="mm"
                />
              </Form.Item>
              <Form.Item
                name="size3"
                rules={[
                  {
                    pattern: /^[1-9]\d*$/,
                    whitespace: true,
                    message: '请输入正整数',
                  },
                ]}
                style={{ width: '25%', marginBottom: '10px' }}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '').replace(/^0+/, '')
                }}
              >
                <Input
                  disabled={filteDisabled('size3', FormState)}
                  onChange={onChange}
                  addonBefore="高"
                  placeholder="请输入"
                  suffix="mm"
                />
              </Form.Item>
              <Form.Item
                name="volume"
                rules={[
                  {
                    max: 13,
                    type: 'string',
                    message: '最大长度13位',
                  },
                ]}
                getValueFromEvent={(e) => {
                  return e.target.value.replace(/[^0-9]/gi, '')
                }}
                style={{ width: '25%', marginBottom: '10px' }}
              >
                <Input
                  addonBefore="体积"
                  placeholder="请输入"
                  disabled={filteDisabled('volume', FormState)}
                  maxLength={30}
                  suffix="mm³"
                  readOnly
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>
        </Col>

        <Col span={8}>
          <div className={Style['deliveryday']}>
            <Space>
              <Form.Item
                label="发货期"
                name="deliveryday"
                rules={
                  !hasDelivery
                    ? [
                        {
                          required: true,
                          pattern: /^[1-9][0-9]{0,8}$/,
                          message: '请输入9位以内正整数',
                        },
                      ]
                    : undefined
                }
              >
                <Input
                  placeholder="请输入"
                  suffix="天"
                  hidden={filteHidden('deliveryday', FormState)}
                  disabled={
                    filteDisabled('deliveryday', FormState)
                      ? true
                      : hasDelivery
                        ? true
                        : false
                  }
                />
              </Form.Item>
              <Checkbox
                onChange={(e) => {
                  e.target.checked && form.resetFields(['deliveryday'])
                  onChangeDelivery(e.target.checked)
                }}
                checked={hasDelivery}
                style={{ marginBottom: '25px' }}
              >
                详询客服
              </Checkbox>
            </Space>
          </div>
          <Form.Item name="deliveryDate" noStyle>
            <Input hidden />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="税收分类编码"
            name="taxCategoryCode"
            rules={[
              {
                required: false, // 7.1.3税收分类编码改为非必填
                pattern: /^[0-9]{19}$/,
                message: '请输入19位的数字或使用智能赋码填充',
              },
            ]}
          >
            <Input
              readOnly
              className={Style['tax-code-input']}
              placeholder="点击选择税收分类"
              onClick={() => setTaxPickerVisible(true)}
              suffix={
                <span onClick={handleTaxCategory}>
                  <ImgCode
                    style={{
                      width: '14px',
                      height: '14px',
                      marginRight: '3px',
                    }}
                  />
                  <Button type="link" style={{ padding: 0 }}>
                    <span>智能赋码</span>
                  </Button>
                </span>
              }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="税收分类名称"
            name="taxCategoryCodeName"
            rules={[
              {
                required: true,
                message: '最长40字',
                whitespace: true,
                max: 40,
              },
            ]}
          >
            <Input disabled placeholder="选择税收分类或智能赋码自动带出" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="简称"
            name="abbreviation"
            {...itemLayou}
            rules={[
              {
                required: true,
                whitespace: true,
                pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,40}$/,
                message: '最多40位中英文或数字',
              },
            ]}
          >
            <Input disabled placeholder="选择税收分类或智能赋码自动带出" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="税率"
            name="taxCategoryRate"
            rules={[
              {
                required: true,
                pattern: /^(0(\.\d{2})?)$/,
                message: '请输入小于1的两位小数数字',
              },
            ]}
          >
            <Input disabled placeholder="选择税收分类或智能赋码自动带出" />
          </Form.Item>
        </Col>
      </Row>
      {/* 选码弹窗 */}
      <TaxCategoryPicker
        visible={taxPickerVisible}
        onCancel={() => setTaxPickerVisible(false)}
        onConfirm={handlePickTaxCategory}
      />
      {/* 智能赋码弹框 */}
      <CustomModal
        open={smartRevenueVisible}
        title="智能赋码"
        modalCancel={closeSmartRevenueVisible}
        width={900}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button size="middle" onClick={closeSmartRevenueVisible}>
              取消
            </Button>
            <Button
              type="primary"
              size="middle"
              onClick={handleConfirmSmartRevenue}
            >
              确认
            </Button>
          </div>
        }
      >
        <Table
          rowKey="revenueCode"
          tableLayout="fixed"
          className={Style['revenue-table-box']}
          size="small"
          rowSelection={{
            selectedRowKeys: selectedRowKeys,
            type: 'radio',
            onChange: handleRevenue,
          }}
          onRow={(record) => ({
            onClick: () => setSelectData(record),
          })}
          dataSource={smartRevenueData}
          columns={smartRevenueColumns}
          pagination={false}
        />
      </CustomModal>
      {/* <Row>
        <Col span={24} style={{ textAlign: 'right', marginTop: 20 }}>
          <Button type="primary" onClick={onFinish}>
            提交
          </Button>
        </Col>
      </Row> */}
    </Form>
  )
}

export default Secondaryinfo
